import { render, staticRenderFns } from "./BuyReport.vue?vue&type=template&id=eb2c4aac&"
import script from "./BuyReport.vue?vue&type=script&lang=js&"
export * from "./BuyReport.vue?vue&type=script&lang=js&"
import style0 from "./BuyReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports